import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: "primary-text-button",
  templateUrl: "./primary-text-button.component.html",
})
export class PrimaryTextButtonComponent {
  @Input() public disabled: boolean;
  @Input() public noLeftPadding: boolean;
  @Input() public noRightMargin: boolean = false;
  @Input() public selected: boolean;
  @Input() public buttonClass = "btn-primary";
  @Output() public onClick = new EventEmitter();

  public click() {
    if (!this.disabled) {
      this.onClick.emit();
    }
  }
}
